export default __webpack_public_path__ + "static/media/13.fd2e429a.png";